import {
    useState
} from "react";
import {
    View
} from "react-native";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme,
    NCoreUIKitToast,
    PageContainer,
    TextInput,
    Button,
    Text
} from "ncore-ui-kit";
import {
    useNavigation
} from "@react-navigation/native";
import type RootStackParamList from "../../navigation/type";
import type {
    NativeStackNavigationProp
} from "@react-navigation/native-stack";

const ForgotPassword = () => {
    const {
        localize
    } = NCoreUIKitLocalize.useContext();

    const {
        spaces
    } = NCoreUIKitTheme.useContext();

    const [
        email,
        setEmail
    ] = useState("");

    const [
        isSubmitting,
        setIsSubmitting
    ] = useState(false);

    const navigation = useNavigation<NativeStackNavigationProp<RootStackParamList>>();

    const handleSendCode = async () => {
        if (!email) {
            NCoreUIKitToast.open({
                title: localize("forgot-password-alert-email-required")
            });
            return;
        }

        if (isSubmitting) {
            return;
        }

        setIsSubmitting(true);

        try {
            const response = await fetch(`${process.env.API_URL}/auth/forgot-password`, {
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email
                }),
                method: "POST"
            });

            const data = await response.json();

            if (data.status === "success") {
                NCoreUIKitToast.open({
                    title: data.message
                });
                navigation.navigate("ResetPassword", {
                    email
                });
            } else {
                NCoreUIKitToast.open({
                    title: data.message || localize("forgot-password-toast-failed")
                });
            }
        } catch {
            NCoreUIKitToast.open({
                title: localize("forgot-password-toast-network-error")
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return <PageContainer
        isScrollable
    >
        <View
            style={[
                stylesheet.container,
                {
                    padding: spaces.spacingXl
                }
            ]}
        >
            <Text
                variant="titleLargeSize"
            >
                {localize("forgot-password-page-title")}
            </Text>
            <Text
                style={{
                    marginBottom: spaces.spacingXl,
                    marginTop: spaces.spacingMd
                }}
                variant="bodyLargeSize"
            >
                {localize("forgot-password-page-subtitle")}
            </Text>
            <View
                style={stylesheet.formContainer}
            >
                <TextInput
                    placeholder={localize("forgot-password-email-placeholder")}
                    keyboardType="email-address"
                    spreadBehaviour="stretch"
                    onChangeText={setEmail}
                    autoCapitalize="none"
                    value={email}
                />
                <View
                    style={{
                        height: spaces.spacingLg
                    }}
                />
                <Button
                    title={localize("forgot-password-submit-button")}
                    spreadBehaviour="stretch"
                    isLoading={isSubmitting}
                    onPress={handleSendCode}
                />
                <View
                    style={[
                        stylesheet.backButtonContainer,
                        {
                            marginTop: spaces.spacingMd
                        }
                    ]}
                >
                    <Button
                        title={localize("forgot-password-back-to-login")}
                        onPress={() => navigation.navigate("Login")}
                        spreadBehaviour="stretch"
                        variant="ghost"
                    />
                </View>
            </View>
        </View>
    </PageContainer>;
};

export default ForgotPassword;
